import request from '@/utils/request'

// 查询法律法规维权典型案例与分析列表
export function listFlwqdxalyfxTzgg(query) {
  return request({
    url: '/web/xwqy/flwqdxalyfxTzgg/list',
    method: 'get',
    params: query
  })
}

// 查询法律法规维权典型案例与分析详细
export function getFlwqdxalyfxTzgg(recid) {
  return request({
    url: '/web/xwqy/flwqdxalyfxTzgg/' + recid,
    method: 'get'
  })
}